import { render, staticRenderFns } from "./plan-affiliations-form.vue?vue&type=template&id=296a18f8&scoped=true"
import script from "./plan-affiliations-form.vue?vue&type=script&lang=ts"
export * from "./plan-affiliations-form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296a18f8",
  null
  
)

export default component.exports